import { Alert, AlertTitle, Box, Button, Container } from "@mui/material"
import { FallbackProps } from "react-error-boundary"
import { useIsLocalhost } from "../utils/hooks"

export const ErrorFallbackPage = ({ error }: FallbackProps) => {
  const isLocalhost = useIsLocalhost()
  return (
    <Container maxWidth='md' sx={{ mb: 4 }}>
      <Alert severity="error" action={
        <Box sx={{display: 'flex', flexDirection: 'column'}}>
          <Button color='inherit' size="small" href="/">HOME</Button>
          <Button color="inherit" size="small" href="/Account/Logout">LOGOUT</Button>
        </Box>
      }>
        <AlertTitle>C'è stato un errore <em>(fare LOGOUT per ricominciare)</em></AlertTitle>
        {error.message}
      </Alert>
      {isLocalhost && <pre>{error.stack}</pre>}
    </Container>
  )
}
export default ErrorFallbackPage